import { Component, OnInit } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
    selector: 'demo-upp-input',
    templateUrl: './demo-upp-input.html',
    styleUrls: ['../demo-common.scss', './demo-upp-input.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DemoUppInputComponent implements OnInit {
    form!: FormGroup;
    isReadonly = false;
    isDisabled = false;

    errorMessages: Record<string, string> = {
        required: 'This field is required',
        minlength: 'Minimum 3 characters',
        email: 'Invalid email format',
    };

    constructor(private change: ChangeDetectorRef) {
    }

    ngOnInit() {
        this.form = new FormGroup({
            name: new FormControl('', [Validators.required, Validators.minLength(3)]),
            email: new FormControl('', [Validators.required, Validators.email]),
            phone: new FormControl(''),
            rate: new FormControl(''),
            pin: new FormControl(''),
        });
    }

    toggleReadonly() {
        this.isReadonly = !this.isReadonly;
        this.change.markForCheck();
    }

    toggleDisabled() {
        this.isDisabled = !this.isDisabled;
        if (this.isDisabled) {
            this.form.disable();
        } else {
            this.form.enable();
        }
        this.change.markForCheck();
    }

    validate() {
        Object.values(this.form.controls).forEach(c => {
            c.markAsTouched();
            c.markAsDirty();
        });
        this.change.markForCheck();
    }

    resetForm() {
        this.form.reset();
        this.isReadonly = false;
        this.isDisabled = false;
        this.form.enable();
        this.change.markForCheck();
    }
}
